import React, { useState, useEffect } from 'react'
import CrudTable from '../table/crudtable'
import { suggestionListService, authService, templateService } from '../../_services'
import SuggestionListForm from './suggestionlistform.component'
import SuggestionSearch from './suggestionsearch'
import MultiSuggestion from './multisuggestion'
import { useTranslation } from "react-i18next"
import { Modal, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMap } from '@fortawesome/free-regular-svg-icons'
import { history } from '../../_helpers';
import moment from 'moment'

function SuggestionList() {

	const [users, setUsers] = useState([])
	const [templates, setTemplates] = useState([])
	const [templatesDownloaded, setTemplatesDownloaded] = useState(false)
	const [showTemplatesModal, setShowTemplatesModal] = useState(false)
	const [showSearchModal, setShowSearchModal] = useState(false)
	const [selectedSuggestionList, setSelectedSuggestionList] = useState(null)
	const [buttons, setButtons] = useState([<SuggestionSearch key="search"/>])
    const {t} = useTranslation('common')

    const initialState = {
        customerId: -1,
        name: '',
        description: '',
        type: 'DOCUMENTATION_NAMES',
        deleteSuggestionIfDocumentationExists: false,
        requiredDocumentationStatus: '',
        suggestions: [],
        suggestionListLicenses: [],
        params: {}
    }

    useEffect(() => {
		templateService.list().then(data => {
			data.sort((a, b) => a.position - b.position || a.name.localeCompare(b.name))
			setTemplates(data)
			setTemplatesDownloaded(true)
		})

		if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
			var newButtons = [<MultiSuggestion key="multi"/>, ...buttons]
			setButtons(newButtons)
		}
    }, [])

    const descriptionFormatter = function(cell) {
        return cell ? cell : '-'
    }

    const typeFormatter = function(cell) {
        if (cell == 'DOCUMENTATION_NAMES') {
            return t('suggestionlist.types.documentationnames')
        } else if (cell == 'TASK_OPTIONS') {
            return t('suggestionlist.types.taskoptions')
        } else if (cell == 'CONTACT_PERSONS') {
            return t('suggestionlist.types.contactpersons')
        }
        return '-'
    }

    const numberOfSuggestionsFormatter = function(cell, row) {
	    return row.suggestions.length
    }

    const templatesFormatter = function(cell, row) {
        var count = templates.filter(template => template.suggestionList === row.id).length
        if (count) {
            return <a href="#" onClick={e => onTemplatesClick(e, row.id)}>{count}</a>
        }
	    return 0
    }

    const getSort = () => {
	    if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
	        return {dataField: 'customerName', order: 'asc'}
	    }
	    return {dataField: 'name', order: 'asc'}
    }

    const onTemplatesClick = (e, suggestionListId) => {
        e.preventDefault()

		setSelectedSuggestionList(suggestionListId)
		setShowTemplatesModal(true)
    }

    const showMap = suggestionListId => {
        history.push('suggestionList/map/' + suggestionListId);
    }

    const columns = [
        {
            dataField: 'customerName',
            text: t('suggestionlist.columns.customer'),
            sort: true,
            sortFunc: (a, b, order, dataField, rowA, rowB) => {
                if (order === 'asc') {
                    return a.localeCompare(b) || rowA.name.localeCompare(rowB.name, undefined, { numeric: true })
                }
                return b.localeCompare(a) || rowB.name.localeCompare(rowA.name, undefined, { numeric: true })
            },
            hidden: !authService.hasRoles(['ROLE_SUPER_ADMIN'])
        },
        {
            dataField: 'name',
            text: t('suggestionlist.columns.name'),
            sort: true,
            sortFunc: (a, b, order) => {
                if (order === 'asc') {
                    return a.localeCompare(b, undefined, { numeric: true })
                }
                return b.localeCompare(a, undefined, { numeric: true })
            }
        },
        {
            dataField: 'description',
            text: t('suggestionlist.columns.description'),
            formatter: descriptionFormatter,
            sort: true
        },
        {
            dataField: 'type',
            text: t('suggestionlist.columns.type'),
            formatter: typeFormatter,
            sort: true
        },
        {
            dataField: 'numberOfSuggestions',
            text: t('suggestionlist.columns.numberofsuggestions'),
            formatter: numberOfSuggestionsFormatter,
            sort: true,
            sortValue: numberOfSuggestionsFormatter
        },
        {
            dataField: 'templates',
            text: t('suggestionlist.columns.templates'),
            formatter: templatesFormatter,
            sort: true
        },
        {
            dataField: 'map',
            text: '',
            formatter: (cell, row) => {
                if (row.suggestions.some(suggestion => suggestion.lat != 1000 && suggestion.lng != 1000)) {
                return <Button size="sm" color="info" variant="outline-secondary" onClick={e => showMap(row.id)}>
						<FontAwesomeIcon icon={faMap}/>
					</Button>
				}
				return <></>
			},
			headerAttrs: { width: 40 },
			attrs: { width: 40 },
            sort: false
        }
    ]

	return (
		<div>
			<h2>
				{t('suggestionlist.label')}
			</h2>
			{ templatesDownloaded &&
				<CrudTable
					service={suggestionListService}
					columns={columns}
					initialState={initialState}
					form={<SuggestionListForm />}
					remote={{"filter": false, "search": false, "pagination": false}}
					sort={getSort()}
					modalSize="xl"
					creatable={authService.hasRoles(['ROLE_SUGGESTION_LIST_WRITE'])}
					editable={authService.hasRoles(['ROLE_SUGGESTION_LIST_WRITE'])}
					deletable={authService.hasRoles(['ROLE_SUGGESTION_LIST_WRITE'])}
					urlParams={true}
					buttons={buttons}
				/>
			}
			<Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={showTemplatesModal}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={() => {setShowTemplatesModal(false)}}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('suggestionlist.columns.templates')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<ul>
						{ templates.filter(template => template.suggestionList === selectedSuggestionList).map(template => {
							return <li key={template.id}>
								<a href={'/template/details/' + template.id} target="_blank">{template.name}</a>
							</li>
						})}
					</ul>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="outline-primary" onClick={() => setShowTemplatesModal(false)}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

export default SuggestionList;